import { Briefcase, Lightning } from "@phosphor-icons/react";

import { Tag } from "common/components/ui/Tag";
import { formatDate } from "common/helpers/utils";
import type { WorkspaceLicense } from "common/types";

import type { JSX } from "react";

import RentedIcon from "assets/icons/plans/avatar-gradient-small.svg?react";

interface LicenseTagProps {
  isRented: boolean;
  license: WorkspaceLicense | undefined;
  size: "sm" | "md";
}

export default function LicenseTag({
  isRented,
  license,
  size,
}: LicenseTagProps) {
  if (isRented)
    return (
      <Tag size={size} variant="tertiary" leftIcon={<RentedIcon />}>
        Avatar
      </Tag>
    );

  let label = "No seat";
  let leftIcon: JSX.Element;

  if (license) {
    if (license.status === "non_renewing") {
      label = `Assigned till ${formatDate(license.expires_at * 1000)}`;
    } else {
      label = license.source === "agency" ? "Agency" : "Outreach";
      leftIcon =
        license.source === "agency" ? (
          <Briefcase weight="fill" className="text-purple-500" />
        ) : (
          <Lightning weight="fill" className="text-orange-500" />
        );
    }
  }

  return (
    <Tag variant="tertiary" leftIcon={leftIcon} size={size}>
      {label}
    </Tag>
  );
}
